(function () {
	const facetsMenu = () => {
		$('html.js .no_submit').click(function(e){
			e.preventDefault();
		})

		$('.open_filters').click(function(){
			$('#open_filters_menu').addClass('show_menu');
			$('body').addClass('overflow-hidden');
		});

		$('.facets-menu__close, .facets__submit, .facets__reset, .form-menu__mask').click(function(){
			$('#open_filters_menu').removeClass('show_menu');
			$('body').removeClass('overflow-hidden');
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		facetsMenu();
	});
	document.addEventListener("shopify:section:load", function () {
		facetsMenu();
	});
})();